import { addDays } from 'date-fns';
import { RawDataItem } from '../../executive-summary/components/funnel-chart/funnel-chart-types';
import { severities } from '../../executive-summary/utils/severity-utils';
import { FilterElements } from '../filters-utils/filters-utils';
import { getCurrentTheme } from '../themes';
import { IssuesScore } from './issues-trends-types';

export const createGraphInfo = (issuesScore: IssuesScore[]) => {
  const data: GraphInfoOutput['data'] = [
    'medium',
    'high',
    'critical',
    'appox',
  ].reduce((acc, key) => {
    if (issuesScore.some(item => item[key] !== 0)) {
      acc[key] = issuesScore.map(item => item[key]);
    }
    return acc;
  }, {});

  const labels = issuesScore.map(item => item.scanDate);

  // in case of one data point - enrich the data
  if (hasOnlyOneDataPoint(labels)) {
    return addEmptyPoint(labels, data);
  }

  return { labels, data };
};

export const createFunnelGraphData = (
  issuesScore: {
    criticality: FilterElements[];
    originalSeverity: FilterElements[];
  },
  minSeverity = 2,
) => {
  const { criticality, originalSeverity } = issuesScore;
  const theme = getCurrentTheme();

  if (criticality && originalSeverity) {
    return severities
      .sort((a, b) => (a.value > b.value ? 1 : -1))
      .reduce((acc, s) => {
        const findSeverity = ({ id }: FilterElements) =>
          id?.toLowerCase() === s.key;
        if (minSeverity > s.value) return acc;

        const startValue = originalSeverity.find(findSeverity)?.count || 0;
        const endValue = criticality.find(findSeverity)?.count || 0;

        if (startValue || endValue)
          acc.push({
            name: s.title,
            color: theme.palette.categoryRiskColor[s.key],
            endValue,
            startValue,
          });
        return acc;
      }, [] as RawDataItem[]);
  }
  return [];
};

const hasOnlyOneDataPoint = (labels: number[]) => labels.length === 1;

const addEmptyPoint = (l: number[], d: GraphInfoOutput['data']) => {
  const currentDate = l[0];
  const dayBefore = addDays(currentDate, -1).getTime();
  const labels = [dayBefore, l[0]];

  const data = Object.keys(d).reduce((acc, curr) => {
    acc[curr] = [0, ...acc[curr]];
    return acc;
  }, d);

  return { labels, data };
};

interface GraphInfoOutput {
  labels: number[];
  data: {
    medium?: number[];
    high?: number[];
    critical?: number[];
    appox?: number[];
  };
}
